export default __webpack_public_path__ + "static/media/wished.6716f2d3.svg";